import firebase from 'firebase'

var config = {
    apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
    authDomain: "tourbrazil-41fbe.firebaseapp.com",
    databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
    projectId: "tourbrazil-41fbe",
    storageBucket: "tourbrazil-41fbe.appspot.com",
    messagingSenderId: "927605208400"
  };
  
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const Email = (e) => {
    return (dispatch) => {
        return dispatch({ type: 'EMAIL', payload: e.target.value})
    }
}

export const Senha = (e) => {
    return (dispatch) => {
        return dispatch({ type: 'SENHA', payload: e.target.value})
    }
}

export const Login = (email, password) => {
    return (dispatch) => {
    dispatch({ type: 'LOGIN_STATE', payload: 'Logando'}) 
    firebase.auth().signInWithEmailAndPassword(email, password)
            .then((user) => {
                dispatch({ type: 'LOGIN_STATE', payload: 'Bem Vindo'})
                return window.location = "/home";
            })
            .catch((error) =>{
                var errorCode = error.code;
                switch (errorCode){
                    case 'auth/user-disabled':
                        return dispatch({ type: 'LOGIN_STATE', payload: 'Este usuário foi desativado.'})
                    case 'auth/invalid-email':
                        return dispatch({ type: 'LOGIN_STATE', payload: 'E-mail inválido.'})
                    case 'auth/user-not-found':
                        return dispatch({ type: 'LOGIN_STATE', payload: 'Usuário não encontrado.'})
                    case 'auth/wrong-password':
                        return dispatch({ type: 'LOGIN_STATE', payload: 'Senha incorreta.'})
                    default: 
                        return dispatch({ type: 'LOGIN_STATE', payload: 'Algo de errado.'})
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/login.js